import { SCHEDULE_DEPLOYMENT } from "fleet/redux-store/scheduled-deployments/actions";
import { DeployV2Page } from "fleet/view/strategy-v2/deploy";
import { connect } from "react-redux";
import { filterByProperty, makeGetAllAsArray } from "redux-store";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { getTargets } from "redux-store/devices/selectors";

const getStrategiesAsArray = makeGetAllAsArray();
const getDevicesAsArray = makeGetAllAsArray();

function mapStateToProps(state) {
  const { app, global } = state;
  const unarchivedStrategies = filterByProperty(
    app.strategies,
    "archived",
    false,
  );

  return {
    strategies: getStrategiesAsArray(unarchivedStrategies),
    targets: getTargets(getDevicesAsArray(global.devices), true),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    scheduleDeployment: (serviceArgs) => {
      const { strategyId, targetIds, deployDate, endDate, deployNow } =
        serviceArgs;

      return createPromiseApiAction(dispatch, SCHEDULE_DEPLOYMENT, [
        strategyId,
        targetIds,
        deployDate,
        endDate,
        deployNow,
      ]);
    },
  };
}

const ConnectedDeployPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeployV2Page);

export { ConnectedDeployPage };
